import * as React from 'react';
export const IcPin = (props: React.SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M20.49 19l-5.16-5.15 3.79-3.79a1.5 1.5 0 00-1.06-2.56h-4.87L8.24 2.59a2 2 0 00-2.83 0L2.59 5.41a2 2 0 000 2.83l5 4.95v4.87a1.5 1.5 0 002.56 1.06l3.79-3.79L19 20.49A1.054 1.054 0 1020.49 19z'
      fill='currentColor'
    />
  </svg>
);
